import './TagButton.scss';
import Component from './TagButton.js';
export default Component;
